import {connect} from "react-redux";
import React, {useRef, useState} from "react";
import {Button, Form} from "react-bootstrap";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {getSyncSearchFormValuesByState} from "../../../helpers/configurationHelper";
import { updatePathCoordinatesDispatchAction} from "../../../state/geoMap/dispatchActions";
import translations from "../../../translations";
import {errorToastNotification, successToastNotification} from "../../../helpers/toastNotificationHelper";
import {getCoordinatesFromGeoJSON} from "../../../helpers/geoJSONHelper";
import {AppParametersType} from "../../../types/app";

interface PropsType {
    configurations: ConfigurationsType,
    selectedArea: ShapeType,
    values: any,
    updatePathCoordinatesActionHandler: any,
    handleCloseModal: any,
    appParameters: AppParametersType
}

const GeoJsonAOIHelper = (props: PropsType) => {
  const {
    configurations,
    selectedArea,
    values,
    updatePathCoordinatesActionHandler,
    handleCloseModal,
    appParameters
  } = props;
  const inputEl: any = useRef(null);
  const [isKml, setIsKml] = useState(true)
  let pathString: any = null;
  let fileLength: any = null;

  const drawArea = () => {
    try {
      JSON.parse(inputEl.current.value)
    } catch (e) {
      errorToastNotification(e.message)
    }

    const geoJson = JSON.parse(inputEl.current.value)
    if (!geoJson.features) {
      errorToastNotification(translations("errorGeoJsonFormat", appParameters.language))
      return;
    }

    if (geoJson.features.length !== 1) {
      errorToastNotification(translations("geoJsonErrorFeatures", appParameters.language))
      return
    }

    const coords = getCoordinatesFromGeoJSON(geoJson.features[0]);
    pathString = coords.map((p) => `${p[0]} - ${p[1]}`).join(", ");
    fileLength = geoJson.features.length;

    if (pathString && fileLength) {
      updatePathCoordinatesActionHandler(configurations, appParameters, selectedArea, values, pathString, appParameters.language)
        .then(() => {
          // eslint-disable-next-line no-template-curly-in-string
          successToastNotification(isKml ? `${translations("geoJSONImportedPathImporter", appParameters.language).replace("${result.polygons.length}", fileLength)}` : `${translations("shapeImportedPathImporter", appParameters.language).replace("${geoJson.features.length}", fileLength)}`);
          pathString = null
          fileLength = null
          handleCloseModal()
        })
    }
  }

  return (
    <>
      <Form.Label className="mb-3">
        {translations("geoJsonLabel", appParameters.language)}
      </Form.Label>
      <div className="path-importer-container">
        <textarea ref={inputEl} style={{width: "100%", minHeight: "200px"}} />
      </div>
      <div className="row mx-0">
        <div className="m-0 px-0 d-flex col-12">
          <p>{translations("circleCenterToolDisclaimer", appParameters.language)}</p>
        </div>
      </div>
      <Button
        onClick={() => {
          drawArea()
        }}
        disabled={pathString}
        className="float-right"
      >
        <span>{translations("done", appParameters.language)}</span>
      </Button>
    </>
  );
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  values: getSyncSearchFormValuesByState(state),
  appParameters: state.application.appParameters
});

const mapDispatchToProps = (dispatch) => ({
  updatePathCoordinatesActionHandler: (configurations: ConfigurationsType, appParameters: AppParametersType, selectedArea: ShapeType, values: any, pathString: string, language: string) => dispatch(updatePathCoordinatesDispatchAction(configurations, appParameters, selectedArea, values, pathString, language))
});

export default connect(mapStateToProps, mapDispatchToProps)(GeoJsonAOIHelper);
